<template>

  <span class="inline_flex popoverRecap"> 
  
  
  
  <van-button icon="cart-o" @click="this.showRecap = true" type="primary" >{{ $t('Demande de devis') }} </van-button>
  
  
  
  
  <van-popup closeable  class=" all_border_radius"  v-model:show="showRecap" style="max-width: 80vw;text-align: left !important;" :style="{ padding: '20px 40px 20px 40px' }">
  
    <h3 class="align-center">{{ $t('Demande de devis') }} </h3>
  
    <van-divider>  </van-divider>
  
    <div class="align-center" >
      {{ $t('Sauvegarder session') }} 
    
  <b>{{ sessionId }}</b>
  </div>
  <van-divider >  </van-divider>
  
  <!--
  <van-space :size="30" wrap>
  
    <div class="all_border_radius" style="    min-width: 220px;
      text-align: center; padding: 10px; background: #f3f2f5" v-for="item in StoreShowPrePanierListe"  :key="item.id">
      
     
  
  <span   v-if="item.pa_ref_palier">
    <b style="vertical-align: sub;margin-right: 10px;">{{ item.ref_prk }}</b>
  
  <van-button v-if="!showDoc(item)"   class="m-r1" size="small"  type="primary">
    <Spinner />
  </van-button>
  
  <van-button  v-if="showDoc(item)" @click="GoFicheTech(item)"  class="m-r1" size="small"  type="primary">
      <van-icon name="description"  size="17px" /> 
  </van-button>
  
  </span>
  
     
    </div>
  </van-space>
  -->
  <!-- input name , email, company , phone, comment -->
  <van-form ref="formMail" @submit="submitFormMail" @failed="submitFormMailFail" class="mb-2" >
    <div class="form-grid" >
  
      
     <div class="form-field">
      <van-field
      name="prenom"
      label-align="top"
      left-icon="user-o"
      class="input_send_mail all_border_radius mb-1"
   
      v-model="prenom"  required type="text" :label="$t('Prénom')" :placeholder="$t('Prénom')"
      :rules="[{ required: true, message: $t('Ce champ est requis') }]"
      />
     </div>
     
      <div class="form-field">
      <van-field
      label-align="top"
      left-icon="user-o"
      name="nom"
      class="input_send_mail all_border_radius mb-1"
  
      v-model="name"  required type="text" :label="$t('Nom')" :placeholder="$t('Nom')"
      :rules="[{ required: true, message: $t('Ce champ est requis') }]"
      />
     </div>
  
  
  
  
      <div class="form-field">
  
      <van-field
      name="email"
      label-align="top"
      class="input_send_mail all_border_radius mb-1"
      left-icon="envelop-o"
      v-model="email"  required  :label="$t('Email')" type="email" :placeholder="$t('Email')" 
      :rules="[{ required: true, message: $t('Ce champ est requis') }]"
      />
      </div>
  
      
      <div class="form-field">
      <van-field
      name="phone"
      label-align="top"
      left-icon="phone-o"
      class="input_send_mail all_border_radius mb-1"
       
      v-model="phone" type="tel" :label="$t('Mobile')" :placeholder="$t('Mobile')" 
      />
      </div>
  
      <div class="form-field">
      <van-field
      name="company"
      label-align="top"
      left-icon="wap-home-o"
      class="input_send_mail all_border_radius mb-1"
    
      v-model="company"  required type="text" :label="$t('Entreprise')" :placeholder="$t('Nom de l\'entreprise')" 
      :rules="[{ required: true, message: $t('Ce champ est requis') }]"
      />
      </div>
    
      
      <div class="form-field">
      <van-field
      name="agence_rexel"
      label-align="top"
      class="input_send_mail all_border_radius mb-1"
    
      v-model="agence_rexel" type="text" :label="$t('Agence Rexel')" :placeholder="$t('Nom de votre agence Rexel')" 
      >

      <template #left-icon>
        <van-image
        style="padding-right:5px;"
      width="45px"
      fit="contain"
      src="https://admin-fibre.gigamedia.net/images/logo/rexel.png"
    />
    </template>
</van-field>
      </div>

  
    </div>
  
  </van-form>
  
  <div class="disclamer_ggm">{{ $t('disclamer rexel') }}</div>
  
  
  <!--
  <span class="van-notice-bar all_border_radius" style="padding: 10px;background:#ecf9ff;color:#1989fa;height: auto;">
   <van-icon  style="margin-left: 0px; margin-right: 20px;" class="icon_info" color="#1989fa"  name="info-o" size="2rem" /> 
    <span class="text-info-number" style="padding: 6px;">
      {{$t('Téléchargez instantanément toutes les fiches techniques de votre session.')}}
      
    </span>
  </span>
  -->
  
  

  <div style="text-align: right !important;">
  
    <van-button
  class="m-r1" 
  plain
  :loading-text="$t('Continuer sans télécharger')"
  :disabled="ficheTechniqueLoading.some(status => status !== false) || $store.state.storePrePanier.StoreShowPrePanierListe.toString() == $store.state.storePrePanier.StorePrePanierAddDevis.toString()" 
    :loading="devisGenEncours" 
  @click="continuNoDownload()" 
  type="primary">
      {{$t('Continuer sans télécharger')}}
  </van-button>
  
  
  <van-button 
    :disabled="ficheTechniqueLoading.some(status => status !== false) || $store.state.storePrePanier.StoreShowPrePanierListe.toString() == $store.state.storePrePanier.StorePrePanierAddDevis.toString()" 
    :loading="devisGenEncours" 
    @click="continueDownload()" 
    :loading-text="$t('Tout télécharger + demander un devis')"
    type="primary" >
    {{$t('Tout télécharger + demander un devis')}}
  </van-button>
  
  
  
  </div>
  
  
  </van-popup>
  </span>
  </template>
  
  <script>
  //import Spinner from '../../loader/LoaderSimple.vue' ;
  import { showNotify } from 'vant';
  export default {
    components: {
     // Spinner,
    },
    data() {
      return {
        showRecap: false,
        name: '',
        prenom: '',
        email: '',
        company: '',
        phone: '',
        agence_rexel: '',
        devisGenEncours: false,
        isFormCompleted: false,
  
      }
    },
    computed: {
      storeSessionId(){
          return this.$store.state.storeUser.sessionId
        },
      showDoc() {
        return (id_perso) => {
  
        return !this.$store.state.storePrePanier.StorePrePanierFicheTechniqueStatus.includes(id_perso.id_perso);
      };
      },
       /** PrePanier du store */
       StoreShowPrePanierListe() {
                      return this.$store.state.storePrePanier.StoreShowPrePanierListe
                  },
  
      StoreEnvWeb() {
                      return this.$store.state.storeGlobal.StoreEnvWeb
                  },
      ficheTechniqueLoading() {
        //console.log("ficheTechniqueLoading")
        //console.log(this.$store.state.storePrePanier.StorePrePanierFicheTechniqueStatus.some(status => status !== false))
                      // check if there is any fiche technique not currently equal to false
                      return this.$store.state.storePrePanier.StorePrePanierFicheTechniqueStatus
                  },
      sessionId() {
        //console.log("ficheTechniqueLoading")
        //console.log(this.$store.state.storePrePanier.StorePrePanierFicheTechniqueStatus.some(status => status !== false))
                      // check if there is any fiche technique not currently equal to false
                      return this.$store.state.storeUser.sessionId
                  },
    },
    created() {
     
        },
    methods:{
     continuNoDownload(){
  
        this.$refs.formMail.submit();
        this.$refs.formMail.validate().then(valid => {
          
  
      this.generateDevis(valid);
  
  }).catch(errors => {
    console.log('errors', errors);
  });
  
      },
      submitFormMail(){
        this.isFormCompleted = true;
      },
      submitFormMailFail(){
        this.isFormCompleted = false;
      },
      continueDownload(){
  
        this.$refs.formMail.submit();
        this.$refs.formMail.validate().then(valid => {
          
  
          this.GoFichesTechs();
        this.generateDevis(valid);
  
  }).catch(errors => {
    console.log('errors', errors);
  });
      },
      logoBtn(){
        if( this.$store.state.storePrePanier.StoreShowPrePanierListe.toString() == this.$store.state.storePrePanier.StorePrePanierAddDevis.toString())
        {return 'success'}else{return 'cart-o'}
      },
      GoFicheTech(item){
  var ref_prk = item.ref_prk.replace(/ /g,'_') + '_' + item.id_perso ;
  window.open(this.$store.state.storeGlobal.StoreApi + '/pdf/' + ref_prk + '.pdf', '_blank');
  },
  
  
       GoFichesTechs(){
  
        //this.addCart();
        
        const jsonData = {};
        jsonData.data = [];
  
        jsonData.push = function(data) {
          this.data.push(data);
        };
  
        
  
        const userId = this.$CryptoJS.AES.encrypt( this.$store.state.storeUser.sessionId , process.env.VUE_APP_SALT_ENCODE).toString();
  
        const refArray = this.$store.state.storePrePanier.StoreShowPrePanierListe
  
  for (let item of refArray) {
    var ref_prk = item.ref_prk.replace(/ /g,'_') + '_' + item.id_perso + '.pdf' ;
    jsonData.push(ref_prk);
  }
        const jsonUrl = JSON.stringify(jsonData.data);
        const jsonUrlEncrypt = encodeURIComponent(this.$CryptoJS.AES.encrypt( jsonUrl , process.env.VUE_APP_SALT_ENCODE).toString());
       // console.log(jsonData);
        //console.log(jsonUrl);
        //console.log(userId);
        //const userId = this.$store.state.storePrePanier.StoreApi
        //var ref_prk = item.ref_prk.replace(/ /g,'_') + '_' + item.id_perso ;
        console.log(this.$store.state.storeUser.lang);
        if(this.$store.state.storeUser.lang == 'fr'){
          window.open(this.$store.state.storeGlobal.StoreApi + '/zip-pdf?i=' + encodeURIComponent(userId) + '&u=' + jsonUrlEncrypt + '&lang=fr'  , '_blank');
        }else{
          window.open(this.$store.state.storeGlobal.StoreApi + '/zip-pdf?i=' + encodeURIComponent(userId) + '&u=' + jsonUrlEncrypt + '&lang=en' , '_blank');
        }
        },
     
     /**
      * Demande de devis
      */
      generateDevis() {
  this.prePanierAfterDevis = JSON.stringify(this.$store.state.storePrePanier.StoreShowPrePanierListe)
  this.prePanierAfterDevis = JSON.parse(this.prePanierAfterDevis)
  this.$store.state.storePrePanier.StorePrePanierAddDevis = this.prePanierAfterDevis
  
  this.devisGenEncours = true;
  
  
  
  const panier = this.$store.state.storePrePanier.StoreShowPrePanierListe;
  const clients = this.$store.state.storeEmailClient.emails;
  
  var userForm =  {
        access_runners : false,
        lang:  this.$store.state.storeUser.lang,
        connected: true,
        nom: this.name,
        prenom: this.prenom,
        mail: this.email,
        tel: this.phone,
        agence_rexel : this.agence_rexel,
        fax: "",
        type: "Externe",
        pays: this.$store.state.storeGlobal.StorePays,
        message_news: false,
        source: "Formulaire",
        'societe-nom': this.company,
        commercialMail: this.$store.state.storeGlobal.contactForm,
      }
  
      var userFormEncrypt = this.$CryptoJS.AES.encrypt( JSON.stringify(userForm) , process.env.VUE_APP_SALT_ENCODE).toString();
  
  fetch(this.$store.state.storeGlobal.StoreApi + '/createDevisPanier', {
    method: "POST",
    //headers: {
    //      'Content-Type': 'application/json'
    //    },
    body: JSON.stringify({
      user: userFormEncrypt, 
      panier: panier, 
      clients: clients ,
      envweb: this.$store.state.storeGlobal.StoreEnvWeb
    
    }),
    //mode: 'no-cors',
  }
  ) 
  .then((response) => { 
  
    return response.json(); 
  })
  .then((data) => {
  
      //Env Formualrei
      if( this.$store.state.storeGlobal.StoreEnvWeb == "Formulaire"){
      
      showNotify({
        className: 'custom-notify',
          message: this.$t('Devis mail gigamedia') ,
          type: 'success',
          duration: 6000,
          position: 'top',
        });
  
    }
  
  
    try {
 
        JSON.parse(data);
    } catch (e) {
        //todo show error
        this.devisGenEncours = false;

        return false;
    }
   
    const parsedData = JSON.parse(data)

    const pk_devis = parsedData.pk_devis
    
    const version = parsedData.version


    for (const [item_id_perso, item] of Object.entries(parsedData.configs)) {
      // get configuration from this.$store.state.storePrePanier.StoreShowPrePanierListe using item_id_perso
      const configuration = this.$store.state.storePrePanier.StoreShowPrePanierListe.find(item => item.id_perso == item_id_perso)
  
      if(typeof configuration.fk_devis === 'undefined' && typeof configuration.pk !== 'undefined') {
        // new devis for configuration
        const values = {
          ligne_devis: item.ligne_devis,
          delai: item.delai,
        }
     
        this.globalFunction.updateLogConfiguration(this, configuration.pk, {"fk_devis": pk_devis, "devis_version": version, ...values }); 
      } else {
        // new devis for configuration with old devis
        configuration.fk_devis = pk_devis
        configuration.devis_version = version
        configuration.ligne_devis = item.ligne_devis
        configuration.delai = item.delai
        this.globalFunction.logConfiguration(this, configuration)
      }
      this.globalFunction.MajLignePrePanierNoPa(this, item_id_perso , 'fk_devis' , pk_devis );
      this.globalFunction.MajLignePrePanierNoPa(this, item_id_perso , 'devis_version' , version );
      this.globalFunction.MajLignePrePanierNoPa(this, item_id_perso , 'ligne_devis' , item.ligne_devis );
      this.globalFunction.MajLignePrePanierNoPa(this, item_id_perso , 'delai' , item.delai );
    }
  
     
  
    this.showRecap = false;
    this.devisGenEncours = false;
  });
  
  },
  }
  
  }
  
  </script>
  
  <style>
  
  </style>
  
  